<template>
  <div class="loading-container" :class="{ 'fullscreen': fullscreen }">
    <div class="loading-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    text: {
      type: String,
      default: 'Chargement...'
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.loading-container.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}

.loading-spinner {
  text-align: center;
}

.spinner-ring {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1d9ed9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 5px;
}

.spinner-ring:nth-child(2) {
  animation-delay: 0.2s;
  border-top-color: #ff6b35;
}

.spinner-ring:nth-child(3) {
  animation-delay: 0.4s;
  border-top-color: #28a745;
}

.loading-text {
  margin-top: 1rem;
  color: #666;
  font-size: 1.1rem;
  font-weight: 500;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .spinner-ring {
    width: 40px;
    height: 40px;
    border-width: 2px;
  }
  
  .loading-text {
    font-size: 1rem;
  }
}
</style> 